<template>
  <div id="IconAndFontSizePanel">
    <div
      class="left"
      :class="{['col-xs-' + 12/$store.getters.divider] : true}"
    >
      <div class="row mlr0 flex">
        <div
          v-if="iconAndFontSize[layoutStyle].hasIconSize"
          :class="
            iconAndFontSize[layoutStyle].hasFontSize
              ? 'col-xs-6'
              : 'col-xs-6 col-xs-offset-3'
          "
        >
          <p>Icon Size</p>
          <el-radio
            v-for="(item, index) in iconSizes"
            :key="index"
            v-model="iconSize"
            :label="item.label"
          >
            <div class="inlineb mlr10">
              <div class="border inlineb">
                <span
                  :title="item.title"
                  class="el-icon-sunny button-icon-small click"
                  :class="item.title"
                ></span>
              </div>
              <p class="name-f">
                {{ item.title }}
              </p>
            </div>
          </el-radio>
        </div>

        <div
          v-if="iconAndFontSize[layoutStyle].hasFontSize"
          :class="
            iconAndFontSize[layoutStyle].hasIconSize
              ? 'col-xs-6'
              : 'col-xs-6 col-xs-offset-3'
          "
        >
          <p>Text Size</p>
          <el-radio
            v-for="(item, index) in fontSizes"
            :key="index"
            v-model="fontSize"
            :label="item.label"
          >
            <div class="inlineb mlr10">
              <div class="border inlineb">
                <span
                  :title="item.title"
                  class="iconfont3 icon-text-big button-icon-small click"
                  :class="item.title"
                ></span>
              </div>
              <p class="name-f">
                {{ item.title }}
              </p>
            </div>
          </el-radio>
        </div>
      </div>
    </div>
    <div class="right" :class="{['col-xs-' + 12/$store.getters.divider] : true, 'bdr-d' : !$store.getters.isVertical, 'bdrt-d' : $store.getters.isVertical}" v-if="format != 'single'">
      <div class="row mlr0 flex">
        <div
          v-if="iconAndFontSize[rightLayoutStyle].hasIconSize"
          :class="
            iconAndFontSize[rightLayoutStyle].hasFontSize
              ? 'col-xs-6'
              : 'col-xs-6 col-xs-offset-3'
          "
        >
          <p>Icon Size</p>
          <el-radio
            v-for="(item, index) in rightIconSizes"
            :key="index"
            v-model="rightIconSize"
            :label="item.label"
          >
            <div class="inlineb mlr10">
              <div class="border inlineb">
                <span
                  :title="item.title"
                  class="el-icon-sunny button-icon-small click"
                  :class="item.title"
                ></span>
              </div>
              <p class="name-f">
                {{ item.title }}
              </p>
            </div>
          </el-radio>
        </div>
        <div
          v-if="iconAndFontSize[rightLayoutStyle].hasFontSize"
          :class="
            iconAndFontSize[rightLayoutStyle].hasIconSize
              ? 'col-xs-6'
              : 'col-xs-6 col-xs-offset-3'
          "
        >
          <p>Text Size</p>
          <el-radio
            v-for="(item, index) in rightFontSizes"
            :key="index"
            v-model="rightFontSize"
            :label="item.label"
          >
            <div class="inlineb mlr10">
              <div class="border inlineb">
                <span
                  :title="item.title"
                  class="iconfont3 icon-text-big button-icon-small click"
                  :class="item.title"
                ></span>
              </div>
              <p class="name-f">
                {{ item.title }}
              </p>
            </div>
          </el-radio>
        </div>
      </div>
    </div>
    <div :class="{['col-xs-' + 12/$store.getters.divider] : true, 'bdr-d' : !$store.getters.isVertical, 'bdrt-d' : $store.getters.isVertical}" v-if="$store.getters.isTriple">
      <div class="row">
        <div
          v-if="iconAndFontSize[tripleRightLayoutStyle].hasIconSize"
          :class="
            iconAndFontSize[tripleRightLayoutStyle].hasFontSize
              ? 'col-xs-6'
              : 'col-xs-6 col-xs-offset-3'
          "
        >
          <p>Icon Size</p>
          <el-radio
            v-for="(item, index) in tripleRightIconSizes"
            :key="index"
            v-model="tripleRightIconSize"
            :label="item.label"
          >
            <div class="inlineb mlr10">
              <div class="border inlineb">
                <span
                  :title="item.title"
                  class="el-icon-sunny button-icon-small click"
                  :class="item.title"
                ></span>
              </div>
              <p class="name-f">
                {{ item.title }}
              </p>
            </div>
          </el-radio>
        </div>
        <div
          v-if="iconAndFontSize[tripleRightLayoutStyle].hasFontSize"
          :class="
            iconAndFontSize[tripleRightLayoutStyle].hasIconSize
              ? 'col-xs-6'
              : 'col-xs-6 col-xs-offset-3'
          "
        >
          <p>Text Size</p>
          <el-radio
            v-for="(item, index) in tripleRightFontSizes"
            :key="index"
            v-model="tripleRightFontSize"
            :label="item.label"
          >
            <div class="inlineb mlr10">
              <div class="border inlineb">
                <span
                  :title="item.title"
                  class="iconfont3 icon-text-big button-icon-small click"
                  :class="item.title"
                ></span>
              </div>
              <p class="name-f">
                {{ item.title }}
              </p>
            </div>
          </el-radio>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "IconAndFontSizePanel",
  props: [],
  data() {
    return {
      artwork: null,
      format: null,
      iconAndFontSize: null,
      layoutStyle: null,
      rightLayoutStyle: null,
      tripleRightLayoutStyle: null,
      iconSize: null,
      fontSize: null,
      rightIconSize: null,
      rightFontSize: null,
      tripleRightIconSize: null,
      tripleRightFontSize: null,
    };
  },
  created: function () {
    this.artwork = this.$store.state.artwork;
    this.iconAndFontSize = this.$store.state.iconFontMap[this.artwork.type];
    this.format = this.artwork.format;
    this.layoutStyle = this.artwork.layoutStyle;
    this.rightLayoutStyle = this.artwork.rightLayoutStyle;
    this.tripleRightLayoutStyle = this.artwork.tripleRightLayoutStyle;
    if (this.artwork.layout == "DR") {
      this.layoutStyle = "socket";
    }
    if (this.artwork.rightLayout == "DR") {
      this.rightLayoutStyle = "socket";
    }
    if (this.artwork.tripleRightLayout == "DR") {
      this.tripleRightLayoutStyle = "socket";
    }
    this.iconSize = this.artwork.iconSize;
    this.fontSize = this.artwork.fontSize;
    this.rightIconSize = this.artwork.rightIconSize;
    this.rightFontSize = this.artwork.rightFontSize;
    this.tripleRightIconSize = this.artwork.tripleRightIconSize;
    this.tripleRightFontSize = this.artwork.tripleRightFontSize;
  },
  watch: {
    iconSize: {
      handler(val) {
        this.$store.state.artwork.iconSize = val;
      },
    },
    fontSize: function (val) {
      this.$store.state.artwork.fontSize = val;
    },
    rightIconSize: function (val) {
      this.$store.state.artwork.rightIconSize = val;
    },
    rightFontSize: function (val) {
      this.$store.state.artwork.rightFontSize = val;
    },
    tripleRightIconSize: function (val) {
      this.$store.state.artwork.tripleRightIconSize = val;
    },
    tripleRightFontSize: function (val) {
      this.$store.state.artwork.tripleRightFontSize = val;
    },
  },

  computed: {
    iconSizes() {
      if (this.iconAndFontSize[this.layoutStyle].hasIconSize) {
        var r = this.iconAndFontSize[this.layoutStyle].iconSize.slice();
        if(this.$store.getters.isFullMetal) {
          r = r.filter((f) => f.title == "Medium");
        } else {
          if (this.artwork.type == "alba") {
            if (
              this.layoutStyle != "iconOnly" &&
              (this.artwork.layout.includes('D') || this.artwork.layout == "M1")
            ) {
              r = r.filter((f) => f.title != "Big"); //remove Big Size
            }
          } else if (
            (this.artwork.type == "aria" || this.artwork.type == "axes") &&
            this.layoutStyle == "iconDoubleLineText"
          ) {
            if (this.artwork.layout == "M1" || this.$store.state.textSizeMap[this.fontSize] == "medium") {
              r = r.filter((f) => f.title != "Medium"); //remove Medium Size
            }
          }
        }
      }
      
      return r;
    },
    rightIconSizes() {
      if (this.iconAndFontSize[this.rightLayoutStyle].hasIconSize) {
        var r = this.iconAndFontSize[this.rightLayoutStyle].iconSize.slice();
        if(this.$store.getters.isFullMetal) {
          r = r.filter((f) => f.title == "Medium");
        } else {
          if (this.artwork.type == "alba") {
            if (
              this.rightLayoutStyle != "iconOnly" &&
              (this.artwork.rightLayout.includes('D') ||
                this.artwork.rightLayout == "M1")
            ) {
              r = r.filter((f) => f.title != "Big"); //remove Big Size
            }
          } else if (
            (this.artwork.type == "aria" || this.artwork.type == "axes") &&
            this.rightLayoutStyle == "iconDoubleLineText"
          ) {
            if (this.artwork.rightLayout == "M1" || this.$store.state.textSizeMap[this.rightFontSize] == "medium") {
              r = r.filter((f) => f.title != "Medium"); //remove Medium Size
            }
          }
        }
        
      }

      return r;
    },
    tripleRightIconSizes() {
      if (this.iconAndFontSize[this.tripleRightLayoutStyle].hasIconSize) {
        var r = this.iconAndFontSize[this.tripleRightLayoutStyle].iconSize.slice();
        if(this.$store.getters.isFullMetal) {
          r = r.filter((f) => f.title == "Medium");
        } else {
          if (this.artwork.type == "alba") {
            if (
              this.tripleRightLayoutStyle != "iconOnly" &&
              (this.artwork.tripleRightLayout.includes('D') ||
                this.artwork.tripleRightLayout == "M1")
            ) {
              r = r.filter((f) => f.title != "Big"); //remove Big Size
            }
          } else if (
            (this.artwork.type == "aria" || this.artwork.type == "axes") &&
            this.tripleRightLayoutStyle == "iconDoubleLineText"
          ) {
            if (this.artwork.tripleRightLayout == "M1" || this.$store.state.textSizeMap[this.tripleRightFontSize] == "medium") {
              r = r.filter((f) => f.title != "Medium"); //remove Medium Size
            }
          }
        }
        
      }

      return r;
    },
    fontSizes() {
      if (this.iconAndFontSize[this.layoutStyle].hasFontSize) {
        var r = this.iconAndFontSize[this.layoutStyle].fontSize.slice();
        if(this.$store.getters.isFullMetal) {
          r = r.filter((f) => f.title == "Medium");
        } else {
          if (this.artwork.type == "alba") {
            if (
              this.layoutStyle != "singleLineText" &&
              (this.artwork.layout.includes('D') || this.artwork.layout == "M1")
            ) {
              r = r.filter((f) => f.title != "Big"); //remove Big Size
            }
          } else if (
            (this.artwork.type == "aria" || this.artwork.type == "axes") &&
            this.layoutStyle == "iconDoubleLineText"
          ) {
            if (this.$store.state.iconSizeMap[this.iconSize] == "medium") {
              r = r.filter((f) => f.title != "Medium"); //remove Medium Size
            }
          }
        }
      }

      return r;
    },
    rightFontSizes() {
      if (this.iconAndFontSize[this.rightLayoutStyle].hasFontSize) {
        var r = this.iconAndFontSize[this.rightLayoutStyle].fontSize.slice();
        if(this.$store.getters.isFullMetal) {
          r = r.filter((f) => f.title == "Medium");
        } else {
          if (this.artwork.type == "alba") {
            if (
              this.rightLayoutStyle != "singleLineText" &&
              (this.artwork.rightLayout.includes('D') ||
                this.artwork.rightLayout == "M1")
            ) {
              r = r.filter((f) => f.title != "Big"); //remove Big Size
            }
          } else if (
            (this.artwork.type == "aria" || this.artwork.type == "axes") &&
            this.rightLayoutStyle == "iconDoubleLineText"
          ) {
            if (this.$store.state.iconSizeMap[this.rightIconSize] == "medium") {
              r = r.filter((f) => f.title != "Medium"); //remove Medium Size
            }
          }
        }
      }

      return r;
    },
    tripleRightFontSizes() {
      if (this.iconAndFontSize[this.tripleRightLayoutStyle].hasFontSize) {
        var r = this.iconAndFontSize[this.tripleRightLayoutStyle].fontSize.slice();
        if(this.$store.getters.isFullMetal) {
          r = r.filter((f) => f.title == "Medium");
        } else {
          if (this.artwork.type == "alba") {
            if (
              this.tripleRightLayoutStyle != "singleLineText" &&
              (this.artwork.tripleRightLayout.includes('D') ||
                this.artwork.tripleRightLayout == "M1")
            ) {
              r = r.filter((f) => f.title != "Big"); //remove Big Size
            }
          } else if (
            (this.artwork.type == "aria" || this.artwork.type == "axes") &&
            this.tripleRightLayoutStyle == "iconDoubleLineText"
          ) {
            if (this.$store.state.iconSizeMap[this.tripleRightIconSize] == "medium") {
              r = r.filter((f) => f.title != "Medium"); //remove Medium Size
            }
          }
        }
      }

      return r;
    },
  },
};
</script>
